import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
function getButtonColorClass(color) {
    switch (color) {
        case 'primary':
            return 'bg-brand-background-primary text-brand-text-primary hover:bg-brand-background-primary-hover focus:ring-brand-background-primary-hover transition-colors duration-300 ease-in-out';
        case 'secondary':
            return 'border bg-brand-background-secondary border-brand-border text-brand-text-secondary hover:bg-brand-background-secondary-hover';
        case 'secondary-selected':
            return 'bg-brand-background-secondary hover:bg-brand-background-secondary-hover text-brand-text-secondary border border-brand-border border-2 ';
        case 'tertiary':
            return 'bg-brand-background-tertiary text-brand-text-tertiary border border-transparent hover:bg-brand-background-tertiary-hover hover:border-brand-border';
        case 'transparent':
            return 'bg-transparent text-brand-text-content border border-transparent hover:border-brand-border focus:ring-brand-border';
        case 'white':
            return 'bg-white text-black hover:bg-gray-100';
        case 'black':
            return 'bg-black text-white border border-white hover:bg-gray-800';
        case 'red':
            return 'bg-red-800 text-white border border-white hover:bg-red-900';
        case 'admin':
            return 'bg-addglow-admin-action-bg border border-addglow-admin-action-border hover:brightness-90 focus:ring-brand-border';
        default:
            throw new Error(`Unknown button color: ${color}`);
    }
}
function getButtonSizeClass(size) {
    switch (size) {
        case 'extra-small':
            return 'py-1 px-2 text-sm';
        case 'small':
            return 'px-3 py-2 text-sm';
        case 'round':
            return 'px-2 py-2 md:px-3 md:py-3 text-sm';
        case 'base':
            return 'px-5 py-2.5 text-sm';
        case 'large':
            return 'px-5 py-5 text-sm';
        case 'icon':
            return 'size-8';
        default:
            throw new Error(`Unknown button size: ${size}`);
    }
}
export const Button = React.forwardRef((props, ref) => {
    const { className, children, disabled, size = 'base', color = 'primary', type = 'button', ariaLabel, onClick, icon, iconPosition = 'left', testId, ...rest } = props;
    return (_jsx("button", { "aria-label": ariaLabel, className: clsx('rounded-full text-center font-medium focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50', getButtonColorClass(color), getButtonSizeClass(size), className), disabled: disabled, onClick: onClick, 
        // a type is being provided but eslint doesn't know
        // eslint-disable-next-line react/button-has-type
        type: type, ref: ref, "data-testid": testId, ...rest, children: icon ? (_jsxs("div", { className: clsx('flex flex-row items-center justify-center', children ? 'space-x-2' : ''), children: [iconPosition === 'left' && icon, children && _jsx("div", { children: children }), iconPosition === 'right' && icon] })) : (children) }));
});
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map